import React from "react";
import { motion } from "framer-motion";
import { TESTIMONIALS } from "../data/content";

export default function Testimonials() {
    return (
        <section
            data-testid="testimonials-section"
            className="relative py-24 sm:py-32 border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 sm:px-10">
                <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
                    <div>
                        <div className="overline mb-4">The Whispers</div>
                        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#f4f4f0]">
                            What men who read it{" "}
                            <span className="italic text-[#990000]">
                                quietly say.
                            </span>
                        </h2>
                    </div>
                    <div className="text-xs tracking-[0.28em] uppercase text-neutral-500">
                        Verified · Anonymized on request
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
                    {TESTIMONIALS.map((t, i) => (
                        <motion.figure
                            key={i}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{
                                duration: 0.8,
                                delay: i * 0.1,
                                ease: [0.16, 1, 0.3, 1],
                            }}
                            data-testid={`testimonial-${i}`}
                            className="bg-[#050505] p-10"
                        >
                            <div className="text-[#7A0000] font-serif-display text-5xl leading-none mb-4">
                                “
                            </div>
                            <blockquote className="font-serif-display italic text-xl sm:text-2xl leading-snug text-neutral-200">
                                {t.quote}
                            </blockquote>
                            <figcaption className="mt-8 flex items-center gap-4">
                                <div className="w-8 h-px bg-[#7A0000]" />
                                <div>
                                    <div className="text-sm text-[#f4f4f0]">
                                        {t.name}
                                    </div>
                                    <div className="text-[10px] tracking-[0.3em] uppercase text-neutral-500">
                                        {t.meta}
                                    </div>
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
